interface AdHeaderProps {
  title: string;
}

export default function AdHeader({ title }: AdHeaderProps) {
  return (
    <h3 className="text-xl font-serif font-bold text-gray-800 mb-4 dark:text-gray-100">{title}</h3>
  );
}
